import { useEffect, useState } from 'react'

/**
 * Returns the browser's online state, kept in sync with `online`/`offline`
 * window events. Default `true` on the first render so SSR-equivalent paths
 * don't flash the offline banner before the listeners attach.
 *
 * `navigator.onLine` is a hint, not a guarantee — a phone with full bars
 * but no actual connectivity will still report online. The point is to
 * catch the cheap case (airplane mode, browser-side network drop) and
 * give the user one clear visual signal.
 */
export function useOnline() {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine
  )

  useEffect(() => {
    function handleOnline() {
      setOnline(true)
    }
    function handleOffline() {
      setOnline(false)
    }
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return online
}
